import type { IndexSymbol } from '@/entities/symbol';
import {
  createUserConfig,
  DEFAULT_DATE_FORMAT_OPTION,
  DEFAULT_TIMEZONE_OPTION,
  EMPTY_OPTION
} from './model';
import type { Option, UserConfig, UserConfigConversation, WatchlistItem } from './types';

export type UserConfigDto = Partial<{
  timezone: Option;
  dateFormat: Option;
  defaultMarket: Option;
  defaultInsight: Option;
  homepage: Option;
  chatHistory: UserConfigConversation[];
  exportVideoExplainerSeen: boolean;
  watchlist: Array<WatchlistItem | IndexSymbol>;
}>;

const normalizeWatchlist = (
  watchlist: Array<WatchlistItem | IndexSymbol> | undefined
): WatchlistItem[] =>
  (watchlist ?? []).map(item =>
    'symbol' in item
      ? item
      : {
          name: item.key.Code,
          symbol: item
        }
  );

const resolveDefaultMarket = (data: UserConfigDto): Option =>
  data.defaultMarket ?? data.defaultInsight ?? EMPTY_OPTION;

const resolveHomepage = (data: UserConfigDto, defaultMarket: Option): Option =>
  data.homepage?.value.length ? data.homepage : defaultMarket;

export const parseUserConfigDto = (data: UserConfigDto): UserConfig => {
  const defaultMarket = resolveDefaultMarket(data);

  return createUserConfig({
    timezone: data.timezone ?? DEFAULT_TIMEZONE_OPTION,
    dateFormat: data.dateFormat ?? DEFAULT_DATE_FORMAT_OPTION,
    defaultMarket,
    homepage: resolveHomepage(data, defaultMarket),
    chatHistory: data.chatHistory ?? [],
    exportVideoExplainerSeen: data.exportVideoExplainerSeen ?? false,
    watchlist: normalizeWatchlist(data.watchlist)
  });
};

export const toUserConfigSavePayload = (userConfig: UserConfig): UserConfig =>
  createUserConfig(userConfig);
